import ScansRow from "./ScansRow";
import ExportToCsv from "./ExportDataIntoExcel";
import { useTranslation } from 'react-i18next';
export default function ScansTable(props) {
  const { rows, getDRDTooltip } = props;
  const{t}=useTranslation();
  const DRAG_AND_DROP=t("DRAG_AND_DROP")
  return (
    <>
      <div className="flex gap-3 align-items-center">
        {getDRDTooltip('drd-scan-table', DRAG_AND_DROP)}
        {/* <ExportToCsv jsonData={props.excelData} filename={"TableData.csv"} /> */}
      </div>
      <div
        className="flex justify-content-around"
        style={{
          margin: "5px 0px 15px 25%",
        }}
      >
        {(rows[0].values || []).map((title) => {
          return (
            <div key={title.label}>
              <label className="font-bold">{title.label}</label>
            </div>
          );
        })}
      </div>
      <div className="flex-column">
        {rows.map((row) => {
          const { key, title, values, bgColor } = row;
          return (
            <ScansRow
              key={key}
              bgColor={bgColor}
              title={title}
              values={values}
            />
          );
        })}
      </div>
    </>
  );
}
